import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faTrafficLight,
} from "@fortawesome/free-solid-svg-icons";

const TrafficBox = ({traffic}) => {



  return (
    <div style={{ display: "flex", justifyContent: "space-around" }}>
      <div style={{ width: "30%", marginTop: "1em" }}>
        <FontAwesomeIcon style={{ width: "20%" }} icon={faTrafficLight} />
        <h3>{traffic.todayTraffic}</h3>
        <h5>Today Traffic Recieved</h5>
      </div>

      <div></div>
      <div style={{ height: "10vh", width: "30%", marginTop: "1em" }}>
        <div class="pie-chart">
          <div class="inner-circle">
            {traffic.TrafficPercentageChange > 0 ? (
              <FontAwesomeIcon
                icon={faArrowTrendUp}
                style={{ color: "#26c030" }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faArrowTrendDown}
                style={{ color: "#dd2754" }}
              />
            )}
          </div>
        </div>
        <h5 className="percentage">{traffic.TrafficPercentageChange}%</h5>
      </div>
    </div>
  );
};

export default TrafficBox;
